<script lang="ts" setup>
import { renderSVG } from '@iconify/iconify'
import type { CSSProperties } from 'vue'
const props = defineProps({
  icon: {
    type: String,
    required: true
  },
  size: {
    type: [Number, String],
    default: 16
  },
  spin: {
    type: Boolean,
    default: false
  }
})

const elRef = ref<HTMLDivElement | null>(null)
const getWrapStyle = computed((): CSSProperties => {
  return {}
})

async function update() {
  const el = unref(elRef)
  if (!el) {
    return
  }

  await nextTick()
  const svg = renderSVG(props.icon)
  if (!svg) {
    const span = document.createElement('span')
    span.className = 'iconify'
    span.dataset.icon = props.icon
    el.textContent = ''
    el.appendChild(span)
  } else {
    el.textContent = ''
    el.appendChild(svg)
  }
}

onMounted(() => {
  update()
})
</script>

<template>
  <span
    ref="elRef"
    :class="[$attrs.class, 'app-iconify anticon', spin && 'app-iconify-spin']"
    :style="getWrapStyle"
  ></span>
</template>

<style lang="scss" scoped>
.app-iconify {
  display: inline-block;

  &-spin {
    svg {
      animation: loadingCircle 1s infinite linear;
    }
  }
}

span.iconify {
  display: block;
  min-width: 1em;
  min-height: 1em;
  border-radius: 100%;
}
</style>
